<template>
  <div class="document">
    <document-header :account="celebration.name" description="Comprovante<br>de Estorno"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Cliente</h4></div>
            <div class="item-box-content">
              <h5>CPF/CNPJ</h5>
              {{ customer.document | documentMasked }}
              <h5>Nome</h5>
              {{ customer.name }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Experiência</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ celebration.document | documentMasked }}
                </div>
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ celebration.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ celebration.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes do Estorno</h3></div>
        <div class="item-box-content">
          <div>
            <div class="row my-3" v-for="item in items" :key="item.heppiReference">
              <div class="col">
                Item: {{ item.item }}
                <br />
                Fatura: {{ item.heppiReference }}
                <br />
                Total: {{ item.amount | price }}
              </div>
              <div class="col">
                Cartão: {{ item.paymentMethod }}
                <br />
                Parcelas: {{ item.installments }}x de {{ (item.amountPaid / item.installments) | price }}
                <br />
                Status: {{ item.status }}
              </div>
            </div>
          </div>
          <hr class="my-3" />
          <div class="row">
            <div class="col-auto pa-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMM YYYY') }}
              </div>
            </div>
            <div class="col pa-5">
              <h5>Motivo</h5>
              {{ description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import documentHeader from '@/components/documentHeader'

export default {
  name: 'chargeback',
  components: {
    documentHeader
  },
  data () {
    return {
      customer: {
        name: 'Julia Roffé de Vasconcelos Lins',
        document: '08819195437'
      },
      celebration: {
        name: 'Senhas Extras - Baile de Formatura FPS18',
        heppiAccount: '6328178-1',
        document: '70526213477'
      },
      items: [
        {
          item: '2x 3° Lote',
          paymentMethod: 'VISA terminado em 4513',
          installments: 2,
          amount: 1300.00,
          amountPaid: 1438.45,
          heppiReference: '6917272ecc470fd0bd0dc702',
          gatewayId: '133807885578',
          status: 'Estornado'
        }
      ],
      date: '2025-11-21',
      description: 'Comprou a senha extra pensando que era para o jantar dos pais'
    }
  },
  created () {
    document.title = 'Comprovante de Estorno - ' + this.celebration.name + ' - ' + this.customer.name + ' - ' + this.$moment(this.date).format('DD-MM-YYYY')
  }
}
</script>
